import {
  RxListCompositeComponent,
  RxReactiveFormCompositeComponent,
  RxTextCompositeComponent,
  RxVideoCompositeComponent,
} from '@nrwl/rx-forms';

import { DialogsConfigService } from '../dialogs-config.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchType } from '@nrwl/rx-models';
import { Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class NotesDialogConfigService extends DialogsConfigService {
  constructor() {
    //private notesValidatorsService: notesValidatorsService
    super();
  }

  public NewCategory() {
    return {
      component: RxReactiveFormCompositeComponent,
      payload: {
        title: 'New Snippet Group',
        placeholder: 'Snippet Group',
        tip: 'All snippets must belong to a snippet group.',
        tipClose: false,
        buttons: this.SubmitDismissButtons(),
        fields: [
          {
            placeholder: 'Snippet Group',
            labelText: null,
            hasInlineInfo: true,
            value: '',
            maxLength: 40,
            validators: [Validators.required, Validators.minLength(2), Validators.maxLength(40)],
            // TODO: Implement async validator for Notes/Snippets category
            // asyncValidators: [this.notesValidatorsService.categoryUniqValidator(SearchType.AccountLibrary)]
          },
        ],
      },
    };
  }

  public NewCategoryItem() {
    return {
      component: RxReactiveFormCompositeComponent,
      payload: {
        title: 'New Snippet',
        placeholder: 'Snippet',
        tip: 'Create new snippet.',
        tipClose: false,
        buttons: this.SubmitDismissButtons(),
        fields: [
          {
            placeholder: 'Snippet',
            labelText: null,
            hasInlineInfo: true,
            value: '',
            maxLength: 40,
            validators: [Validators.required, Validators.minLength(2), Validators.maxLength(40)],
            // TODO: Implement async validator for Notes/Snippets category
            // asyncValidators: [this.notesValidatorsService.categoryUniqValidator(SearchType.AccountLibrary)]
          },
        ],
      },
    };
  }

  public SelectCategory(items$: Observable<any[]>) {
    return {
      component: RxListCompositeComponent,
      payload: {
        title: 'Select Category',
        items$: items$,
        buttons: this.SubmitDismissButtons('Select'),
      },
    };
  }

  public DeselectAllConfirmation() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Do you want to deselect all forms?',
        tip: 'TODO: Explanatory message for RWE-179',
        buttons: this.SubmitDismissButtons('Yes', 'No'),
      },
    };
  }

  public HelpCenter() {
    return {
      component: RxVideoCompositeComponent,
      payload: {
        title: 'Help Center',
        buttons: this.DismissButton(),
      },
    };
  }
}
